import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Container } from "../../components/simple";
import ModalMessage from "../../components/complex/ModalMessage";
import { SignInModal } from "../../components/forms/Auth/Login";
import { userMessage } from "../../store/actions/auth";
import { paramsToObject } from "../../api/params";
import Api from "../../api";
import * as routes from "../../router/routes";

import "../../styles/shared/unauthed.scss";

function SignInScreen(props) {
  document.title = "Login | Global Data Resources";

  const {
    location: { search },
    history,
    activatedMessage,
    resetMessage
  } = props;
  const [isLoginModal, handleStateLoginModal] = useState(true);

  useEffect(() => {
    const params = paramsToObject(search);
    if (!activatedMessage && params.token) {
      const activateUser = async data => {
        await Api.user.activate({ data });
      };

      activateUser(params);
    }
  }, [activatedMessage, search]);

  const closeWelcomeModal = () => {
    resetMessage();
    history.replace(routes.signIn);
  };

  const goBackActionLogin = () => {
    handleStateLoginModal(!isLoginModal);
    history.goBack();
  };

  const handleLogin = async data => {
    await Api.auth.login({ data });
  };

  return (
    <Container className="unauthed-container-background" fluid>
      <SignInModal
        isOpen={isLoginModal}
        goBackAction={goBackActionLogin}
        handleSubmit={handleLogin}
      />
      <ModalMessage
        isOpen={!!activatedMessage}
        goBackAction={closeWelcomeModal}
        showGoBackArrow={false}
        // message={activatedMessage}
        title="Your password has been changed!"
        message=""
      />
    </Container>
  );
}

SignInScreen.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    replace: PropTypes.func
  }).isRequired,
  activatedMessage: PropTypes.string.isRequired,
  resetMessage: PropTypes.func.isRequired
};

const mapStateToProps = ({ userProfile }) => {
  return {
    activatedMessage: userProfile.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetMessage: () => dispatch(userMessage(""))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInScreen);
